<template>
  <div>
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5>Customer</h5>
          </div>
          <div class="card-body">
            <ul class="nav nav-tabs nav-bordered">
              <li class="nav-item"><a href="#data-customer" data-toggle="tab" aria-expanded="false" class="nav-link active">Data</a></li>
              <li class="nav-item"><a href="#data-customer-by-salesman" data-toggle="tab" aria-expanded="false" class="nav-link">Customer By Salesman</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="data-customer">
                <div class="table-responsive">
                  <div class="alert alert-info alert-dismissible fade show" role="alert">
                    <strong>Info Rating:</strong> Group A (&lt; 61 day), Group B (&lt; 68 day), Group C (&lt; 75 day), Group D (&ge; 75 day), Group E (Black List)
                  </div>
                  <div class="form-inline ml-auto">
                    <div class="button-group">
                      <button type="button" class="btn btn-sm btn-soft-primary dropdown-toggle" data-toggle="dropdown" id="dropDownFilter">Action<span class="caret"></span></button>
                      <ul class="dropdown-menu p-2" aria-labelledby="dropDownFilter">
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="calcOutstanding">Recalculate Outstanding</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1" @click="checkRating">Re-Rating</a></li>
                      </ul>
                      <button type="button" class="btn btn-sm btn-soft-primary waves-light waves-effect" @click="addCustomer">
                        <i class="fa fa-plus" aria-hidden="true"></i> New
                      </button>
                      <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                    </div>
                    <div class="button-group">
                      <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <i class="fa fa-filter" aria-hidden="true"></i>
                          Filter
                          <span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu p-2" >
                        <span>Rating:</span>
                        <div class="dropdown-divider"></div>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterRating" value="good"/> Group A</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterRating" value="middle-low"/> Group B</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterRating" value="middle-high"/> Group C</a></li>
                        <li><a href="javascript:void(0)" class="small" tabIndex="-1"><input type="checkbox" v-model="filterRating" value="bad"/> Group D</a></li>
                      </ul>
                      rows:
                      <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total: <b>{{ rowsTotal }}</b>
                      </span>
                    </div>

                    <div class="form-group mx-sm-3 mb-2">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                    </div>
                    <span class="mr-1">
                      page:
                      <select v-model="currentPage">
                        <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                      </select>
                      / {{ pageLength }}
                    </span>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                  </div>
                  <table class="table table-item mb-0 table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <!-- <th>
                              <label class="form-checkbox">
                                <input type="checkbox" v-model="selectAll" @click="select">
                                <i class="form-icon"></i>
                              </label>
                            </th> -->
                            <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                {{ t.name }}
                                <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filterData.length < 1">
                        <td colspan="10" style="text-align: center;"><i>No Data</i></td>
                      </tr>
                        <tr v-for="u in filterData" v-bind:key="u.id" @click="editCustomer(u.id)" style="cursor: pointer">
                          <!-- <td>
                            <label class="form-checkbox">
                              <input type="checkbox" :value="u.id" v-model="selected">
                              <i class="form-icon"></i>
                            </label>
                          </td> -->
                          <td>
                          <span v-if="u.rating_check === true">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          </span>
                          <span v-else>
                            <span class="badge badge-success" v-if="u.rating_id === 'good'">{{ u.rating }}</span>
                            <span class="badge badge-danger" v-else-if="u.rating_id === 'bad'">{{ u.rating }}</span>
                            <span class="badge badge-warning" v-else>{{ u.rating }}</span>
                          </span>
                          </td>
                          <td>{{ u.termDueDate }}</td>
                          <td><b>{{ u.customer_no }}</b></td>
                          <td>{{ u.group }}</td>
                          <td>{{ u.name }}</td>
                          <td>{{ u.phone }}</td>
                          <td>{{ u.address }}</td>
                          <td>{{ u.notes }}</td>
                          <td>{{ u.area }}</td>
                          <!-- <td>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="u.outstanding_load === true"></span>
                            <span v-else>{{ u.outstanding | currency }}</span>
                          </td> -->
                          <td>
                            <span v-if="u.active === true"><i class="fa fa-check" style="color: green"></i></span>
                          </td>
                          <!-- <td>{{ u.order_count }}</td> -->
                        </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="tab-pane" id="data-customer-by-salesman">
                <div class="table-responsive" style="min-height: 640px">
                  <div class="form-inline ml-auto">
                    <span>Salesman:</span>
                    <span class="ml-1 mr-2">
                      <v-select :options="salesmanSelect" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom"/>
                    </span>
                    <span>Area:</span>
                    <span>
                      <select v-model="area_id" class="form-control">
                        <option v-for="a in areaList" :key="a.id" :value="a.id">{{ a.name }}</option>
                      </select>
                    </span>
                    <div class="button-group">
                      rows:
                      <select id="select-rows" v-model="pageSize2" @change="setPageSizeOnChange">
                        <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                      </select>
                      <span class="mr-1">
                        Total rows: <b>{{ filterData2.length }}</b>
                      </span>
                      <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                      <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="getCustomerBySalesman">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                        <button class="btn btn-warning btn-sm dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fa fa-print" aria-hidden="true"></i> Print
                        </button>
                        <div class="dropdown-menu" aria-labelledby="print">
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                          <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                        </div>
                        <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery2"> -->
                    </div>
                    <span class="mr-1">{{ currentPage2 }} / {{ pageLength2 }}</span>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                  </div>
                  <div v-for="(d, index) in filterData2" :key="index" class="mt-5">
                    <h5><b>{{ d.name }}</b></h5>
                    <table class="table table-item mb-0 table-sm table-hover table-striped">
                      <thead>
                        <th>Customer No</th>
                        <th>Customer</th>
                        <th>Address</th>
                        <th>Phone</th>
                        <th>NPWP</th>
                        <th>Area</th>
                      </thead>
                      <tbody>
                        <tr v-for="c in d.customers" :key="c.customer_no">
                          <td>{{ c.customer_no }}</td>
                          <td>{{ c.customer }}</td>
                          <td>{{ c.address }}</td>
                          <td>{{ c.phone }}</td>
                          <td>{{ c.vat }}</td>
                          <td>{{ c.area }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <hr>
                </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <CustomerBirthdayModal @setBirthday="setBirthday"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { customerUrl, customer2Url, getHeader } from '@/config'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import CustomerBirthdayModal from '@/components/customer/CustomerBirthdayModal.vue'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'CustomerList',
  props: ['scroll'],
  components: {
    Loading,
    CustomerBirthdayModal,
    DatePicker
  },
  data () {
    var date = new Date()
    const date1 = new Date(date.getFullYear(), 0, 1)
    const date2 = new Date(date.getFullYear(), date.getMonth(), date.getDate())
    return {
      filterRating: [],
      area_id: '',
      startDate: [date1, date2],
      salesman_id: '',
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      dataRaw2: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 25,
      currentPage: 1,
      sortColumn2: '',
      ascending2: false,
      searchQuery2: '',
      currentPage2: 1,
      pageSize2: 100,
      title: [{
        name: 'Rating',
        prop: 'rating_id'
      }, {
        name: 'Term Due',
        prop: 'term_due_id'
      }, {
        name: 'Customer No.',
        prop: 'customer_no'
      }, {
        name: 'Group',
        prop: 'group'
      }, {
        name: 'Name',
        prop: 'name'
      }, {
        name: 'Phone',
        prop: 'phone'
      }, {
        name: 'Address',
        prop: 'address'
      }, {
        name: 'Notes',
        prop: 'notes'
      }, {
        name: 'Area',
        prop: 'area'
      }, {
        name: 'Active',
        prop: 'active'
      }],
      selectAll: false,
      selected: []
    }
  },
  mounted () {
    this.refreshListAll()
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      employeeList: state => state.employees.employeeList,
      areaList: state => state.area.areaList
    }),
    salesmanSelect () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = []
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    pageLength2: function () {
      var count = 0
      if (this.searchQuery2.length < 0 || this.searchQuery2 === null) {
        count = this.dataRaw2.length
      } else {
        count = this.dataRaw2
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery2.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize2

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      count = this.dataRaw.filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterRating.length > 0) {
          for (let i = 0; i < this.filterRating.length; i++) {
            if (d.rating_id === this.filterRating[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).length
      // console.log(count)
      return count
    },
    rowsTotal2: function () {
      var count = 0
      if (this.searchQuery2.length < 0 || this.searchQuery2 === null) {
        count = this.dataRaw2.length
      } else {
        count = this.dataRaw2
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery2.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterRating.length > 0) {
          for (let i = 0; i < this.filterRating.length; i++) {
            if (d.rating_id === this.filterRating[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    },
    filterData2 () {
      var col = this.sortColumn2
      var ascending = this.ascending2
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw2.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery2.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage2 - 1) * this.pageSize2
        const end = this.currentPage2 * this.pageSize2
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async checkRating () {
      var check = false
      await this.$swal.fire({
        title: 'Are you sure to Re-Rating Customer data?',
        text: "You won't be able to revert this!",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!'
      }).then((result) => {
        if (result.value) {
          check = true
        } else {
          check = false
        }
      })
      if (check === true) {
        var array = this.dataRaw
        for (let i = 0; i < array.length; i++) {
          array[i].rating_check = true
        }
        for (let i = 0; i < array.length; i++) {
          await axios.post(customerUrl + '/sales-outstanding-expire', { customer_no: array[i].customer_no }, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
            .then(response => {
              console.log(response.data.rating)
              array[i].rating_id = response.data.rating_id
              array[i].rating = response.data.rating
              array[i].rating_check = false
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
              array[i].rating_check = false
            })
        }
        await this.$swal('Customer', 'Finish Re-Rating Customer data', 'success')
      }
    },
    async getCustomerBySalesman () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        area_id: this.area_id
      }
      console.log(obj)
      await axios.post(customerUrl + '/salesman', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw2 = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async refreshListAll () {
      this.$Progress.start()
      this.loader.isLoading = true
      await axios.get(customerUrl, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
      // var arr = this.dataRaw
      // await this.outstandingLoadTrue()
      // for (let i = 0; i < arr.length; i++) {
      //   var obj = {
      //     customer_no: arr[i].customer_no,
      //     year: '2022',
      //     date: '2022-06-03',
      //     company: null
      //   }
      //   await axios.post(customerUrl + '/piutang-sales', obj, { headers: getHeader() })
      //     .then(response => {
      //       console.log(response.data.message)
      //       arr[i].outstanding = response.data.total_outstanding
      //       arr[i].outstanding_overdue = response.data.total_outstanding_overdue
      //     })
      //     .catch(error => {
      //       console.log(error)
      //       console.log(error.response)
      //     })
      // }
      // await this.outstandingLoadFalse()
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      await axios.get(customerUrl, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.dataRaw = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.searchQuery = ''
          window.scrollTo(0, this.scroll)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          throw error
        })
    },
    async calcOutstanding () {
      var array = this.dataRaw
      var date = new Date()
      var year = date.getFullYear()
      var newDate = year + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      await this.outstandingLoadTrue()
      for (let i = 0; i < array.length; i++) {
        var obj = {
          customer_no: array[i].customer_no,
          year: year,
          date: newDate,
          company: null
        }
        await axios.post(customerUrl + '/piutang-sales', obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
          .then(response => {
            console.log(response.data.message)
            array[i].outstanding = response.data.total_outstanding
            array[i].outstanding_overdue = response.data.total_outstanding_overdue
            array[i].outstanding_load = false
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
      await this.outstandingLoadFalse()
      await this.$swal('Customer', 'success get outstanding customer', 'success')
    },
    outstandingLoadTrue () {
      var array = this.dataRaw
      for (let a = 0; a < array.length; a++) {
        array[a].outstanding_load = true
      }
    },
    outstandingLoadFalse () {
      var array = this.dataRaw
      for (let a = 0; a < array.length; a++) {
        array[a].outstanding_load = false
      }
    },
    sendMessage: function () {
      var obj = {
        number: '085950325293',
        message: 'Selamat ulang tahun \n\n Terima kasih',
        key: '035c6f2f79a8284cd7a2cfafc01fc713'
      }
      axios.post('localhost:8081/send-message', obj)
        .then(response => {
          console.log(response)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    setBirthday: function (value) {
      axios.post(customerUrl + '/birthday', value, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          console.log(response.data.data)
          this.dataRaw = response.data.data
          if (response.data.data.length === 0) {
            this.refreshList()
          }
          this.$swal(
            'Sucess',
            response.data.message,
            'success'
          )
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            error.response.data.message,
            'error'
          )
        })
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    editCustomer (id) {
      // this.data = this.dataRaw.find(todo => todo.id === id)
      axios.get(customerUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('editCustomer', response.data.data)
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    addCustomer () {
      this.$emit('newCustomer', true)
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw2
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await axios.post(customer2Url + '/customer-by-salesman', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style>
.spinner-border-sm {
  color: #6FB56F
}
</style>
